export default {
  heights: {
    desktop: 350,
    tablet: 320,
    mobile: 315,
  },
  iframeSrc:
    'include/vjafwest/1365-2024-us-presidential-election-banner/{service}/app',
  iframeDevSrc:
    'include/vjafwest/1365-2024-us-presidential-election-banner/develop/{service}/app',
  usElectionThingId: '647d5613-e0e2-4ef5-b0ce-b491de38bdbd',
  editorialSensitivityId: 'f2b5dd0e-dda0-454c-893d-792d46ff48c3',
};
